export interface Request {
  searchField: string | null;
  searchQuery: string | null;
  with: string | null;
  where: string | null;
  whereIn: string | null;
  orWhere: string | null;
  orderBy: string | null;
  orderType: string | null;
  filterBy: string | null;
  filterValue: string | null;
  limit: string | null;
  paginate: string | null;
  page: number | null;
}

export class Request implements Request {
  public searchField: string | null;
  public searchQuery: string | null;
  public with: string | null;
  public where: string | null;
  public whereIn: string | null;
  public orWhere: string | null;
  public orderBy: string | null;
  public orderType: string | null;
  public filterBy: string | null;
  public filterValue: string | null;
  public limit: string | null;
  public paginate: string | null;
  public page: number | null;

  constructor() {
    this.searchField = null;
    this.searchQuery = "";
    this.with = null;
    this.where = null;
    this.whereIn = null;
    this.orWhere = null;
    this.orderBy = null;
    this.orderType = null;
    this.filterBy = null;
    this.filterValue = null;
    this.limit = null;
    this.paginate = null;
    this.page = null;
  }
}
